import React from "react";
import { useLocation } from "react-router-dom";
import img from '../../images/zyntra.png'
const Zyntra = () => {
   const location = useLocation();
   
    const prod =  {
      "id": 7,
      "img": "https://maple-blogs.s3.ap-south-1.amazonaws.com/products/product_SDWN.png",
      "img2": "https://maple-blogs.s3.ap-south-1.amazonaws.com/products/agent-net.png",
      "head_name": "Zero Trust Network Access (ZTNA) solution",
    
      "intro": "Introduction",
      "intro_description": "Zyntra, developed by Maple Cloud Technologies, is a next-generation Zero Trust Network Access (ZTNA) solution designed to provide secure, seamless, and efficient connectivity for businesses of all sizes. Unlike traditional security models, Zyntra enforces a zero-trust approach, ensuring that no user, device, or application is trusted by default. Access is granted only after rigorous authentication and continuous verification, minimizing cyber threats nd unauthorized access. By implementing granular, identity-based access controls, Zyntra eliminates excessive network exposure and secures direct, encrypted connections to applications. Unlike VPNs, which expose entire networks, Zyntra grants access only to authorized users and resources, reducing the risk of data breaches while maintaining optimal performance. Whether securing remote  workforces, cloud applications, or regulatory compliance, Zyntra delivers a scalable and future-ready security framework for modern businesses",
       "ques": "Why Choose Zyntra?",
      "ques_description": "Organizations need a modern, scalable, and zero-trust-driven security solution to protect their evolving digital ecosystems. Zyntra delivers: A future-ready security model that eliminates implicit trust and continuously verifies every access request. Intelligent network segmentation to ensure least-privileged access, preventing lateral movement within the network.implified deployment & seamless integrations with existing IT and security infrastructure.A cost-effective, cloud-native solution that adapts to businesses of all sizes.",
   
      "topics": [
        {
          "title": "Core Benefits ",
          "benefits": [
            {
              "title": "Eliminate VPN Security Risks :",
              "content": "Traditional VPNs create vulnerabilities by exposing IP addresses and networks. Zyntra removes these risks by granting access only to specific applications, not entire networks."
            },
            {
              "title": "Enhanced Cybersecurity Posture :",
              "content": "Zyntra’s zero-trust approach significantly reduces attack surfaces, making it harder for cybercriminals to exploit weaknesses."
            },
            {
              "title": "Seamless User Experience :",
              "content": "Employees, contractors, and partners enjoy a frictionless, secure access experience without the complexity of outdated security models."
            },
            {
              "title": " Lower Operational Costs :",
              "content": "By eliminating the need for costly VPN infrastructure and reducing IT overhead, Zyntra optimizes security while cutting expenses."
            },
            {
              "title": "Compliance & Regulatory Adherence : ",
              "content": "Zyntra helps businesses comply with industry regulations such as GDPR, HIPAA, ISO 27001, and NIST, ensuring data security and privacy."
            },
            {
              "title": " Scalability & Future-Ready Security : ",
              "content": "Whether an enterprise has 50 employees or 50,000, Zyntra seamlessly scales to accommodate business growth without compromising security."
            }
          ]
        },
        {
          "title": " Features",
          "benefits": [
            {
              "title": "Zero Trust Architecture :",
              "content": "Traditional networks rely on implicit trust, leading to potential breaches. Zyntra eliminates this risk by enforcing strict identity verification and continuously validating every connection request."
            },
            {
              "title": "End-to-End Encryption :",
              "content": "Ensures that data is protected in transit with strong encryption protocols, preventing interception and unauthorized access."
            },
            {
              "title": "Micro-Segmentation :",
              "content": "Divides networks into isolated segments, ensuring that users can only access specific applications they are authorized for—reducing the risk of lateral movement in case of a security breach."
            },
            {
              "title": "Identity-Centric Access Management : ",
              "content": "Employs robust authentication mechanisms such as Multi-Factor Authentication (MFA), Single Sign-On (SSO), and Role-Based Access Control (RBAC) to enhance security."
            },
            {
              "title": "Secure Remote Access Without VPNs : ",
              "content": "Unlike traditional VPN solutions that expose network vulnerabilities, Zyntra provides direct, encrypted application access without exposing IP addresses or network infrastructure to the public internet."
            },
            {
              "title": "Cloud-Native & Hybrid Deployment : ",
              "content": "Whether your business operates on-premises, in the cloud, or in a hybrid nvironment, Zyntra seamlessly adapts to your IT ecosystem with flexible deployment options."
            },
            {
              "title": "Advanced Threat Detection & Real-Time Monitoring :",
              "content": "Leverage AI-driven analytics and continuous security posture assessments to identify and mitigate potential threats in real-time."
            },
            {
              "title": "Seamless Integration :",
              "content": "Works effortlessly with leading Identity and Access Management (IAM) solutions, Security Information and Event Management (SIEM) systems, and existing security frameworks."
            },
            {
              "title": "Adaptive Access Policies :",
              "content": "Dynamically enforces security policies based on user behavior, device posture, location, and other contextual factors."
            }
          ]
        }
      ]
    }
  return (
    <div className="blog w-full ">
    <div className="flex pt-20 max-[900px]:flex-wrap w-full justify-between">
      <div className="w-full max-[900px]:w-full flex flex-col  gap-5 text-white text-md p-8 text-md">
        <div className="w-full flex items-center justify-center">
          <img
            src={img}
            alt="img"
            loading="lazy"
            className="w-4/5 max-[400px]:w-full h-[380px] rounded-xl"
          />
        </div>
        <div className="w-full flex text-lg items-center  gap-2">
          {prod.head_name}
        </div>
        <h1 className="text-white text-2xl font-medium">Introduction</h1>
        <p>{prod.intro_description}</p>
        <h1 className="text-white text-2xl font-medium">{prod.ques}</h1>
        <p>{prod.ques_description}</p>
        {prod.topics.map((data) => (
          <div key={data.id} className="w-full flex flex-col gap-4">
            <h1 className="text-white text-2xl font-medium">{data.title}</h1>

            {data.benefits.map((point, index) => (
              <li key={index}>
                <span className="font-medium text-white"> {point.title}</span>{" "}
                {point.content}
              </li>
            ))}
          </div>
        ))}
      </div>
    </div>
  </div>
  );
};

export default Zyntra; 
